import ApiService from './ApiService';

export async function apiVerificarMfa(data) {
  return ApiService.fetchData({
    url: '/core/prin/inic-sesi/iniciar-sesion/verificarMfa/',
    method: 'post',
    data
  });
}

export async function apiSignIn(data) {
  return ApiService.fetchData({
    url: '/core/prin/inic-sesi/iniciar-sesion/iniciarSesion/',
    method: 'post',
    data
  });
}

export async function apiConfigurarInicio(data) {
  const response = await ApiService.fetchData({
    url: '/core/prin/inic-sesi/iniciar-sesion/configurarInicio/',
    method: 'post',
    data
  });
  if (response.data.success === false) {
    throw new Error(response.data.message);
  }
  return response;
}

export async function apiConfigurarCambioSucursal(data) {
  return ApiService.fetchData({
    url: '/core/prin/inic-dash/dashboard/cambiarSucursal/',
    method: 'post',
    data
  });
}

export async function apiObtenerSubsidiariasUsuario() {
  return ApiService.fetchData({
    url: '/core/prin/inic-dash/dashboard/obtenerSubsidiariasUsuario/',
    method: 'get'
  });
}

export async function apiConfigurarCambioSubsidiaria(data) {
  return ApiService.fetchData({
    url: '/core/prin/inic-dash/dashboard/cambiarSubsidiaria/',
    method: 'post',
    data
  });
}

export async function api_obtenerImagen(params) {
  try {
    return await ApiService.fetchData({
      url: '/core/prin/inic-sesi/iniciar-sesion/obtenerImagenPerfil/',
      method: 'get',
      params: params
    });
  } catch (error) {
    console.error(error);
  }
}

export async function apiSignUp(data) {
  return ApiService.fetchData({
    url: '/sign-up',
    method: 'post',
    data
  });
}

export async function apiSignOut(data) {
  return ApiService.fetchData({
    url: '/sign-out',
    method: 'post',
    data
  });
}

export async function apiForgotPassword(data) {
  return ApiService.fetchData({
    url: '/core/prin/inic-recu/recuperar-contra/recuperarPassword/',
    method: 'post',
    data
  });
}

export async function apiResetPassword(data) {
  return ApiService.fetchData({
    url: '/core/prin/inic-rese/reset-password/resetPassword/',
    method: 'post',
    data
  });
}
